import { cn } from '@/lib/utils';

interface Props {
  venue?: string;
  className?: string;
}

const STYLES: Record<string, { label: string; className: string }> = {
  kalshi: { label: 'Kalshi', className: 'bg-success/10 text-success border-success/30' },
  kx: { label: 'Kalshi', className: 'bg-success/10 text-success border-success/30' },
  polymarket: { label: 'Polymarket', className: 'bg-blue-500/10 text-blue-600 border-blue-500/30' },
  polymarket_us: { label: 'Polymarket US', className: 'bg-blue-500/10 text-blue-600 border-blue-500/30' },
  limitless: { label: 'Limitless', className: 'bg-violet-500/10 text-violet-600 border-violet-500/30' },
};

export const VenueBadge = ({ venue, className }: Props) => {
  const key = (venue || '').toLowerCase();
  const style = STYLES[key] ?? {
    label: venue ? venue.replace(/_/g, ' ') : 'Unknown',
    className: 'bg-muted text-muted-foreground border-border',
  };
  return (
    <span
      className={cn(
        'inline-flex items-center text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded border',
        style.className,
        className
      )}
    >
      {style.label}
    </span>
  );
};

export default VenueBadge;
